module.exports = __webpack_public_path__ + "img/triangle-icon.3e8515e7.svg";